// extracted by mini-css-extract-plugin
export default {"root":"root--qHz55"};